var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-table-simple',{attrs:{"items":_vm.items,"columns":_vm.columns,"stacked":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Active payment account ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }